import { Button, Stack, Typography, type ButtonProps } from '@mui/material';
import classNames from 'classnames';
import { forwardRef, type ReactNode } from 'react';

import { AuthorizationTooltip } from '../tooltips/authorizationTooltip';
interface ButtonWithIconProps extends ButtonProps {
  icon?: string | ReactNode;
  iconPosition?: 'left' | 'right';
  text: ReactNode;
  isAuthorized?: boolean;
  dataTestId?: string;
  textClassName?: string;
  disabledTooltip?: string;
}

const ButtonWithIcon = forwardRef<HTMLButtonElement, ButtonWithIconProps>(
  (props, ref) => {
    const {
      icon,
      text,
      dataTestId,
      className,
      textClassName,
      iconPosition = 'left',
      isAuthorized = true,
      disabledTooltip,
      disabled,
      ...rest
    } = props;

    return (
      <AuthorizationTooltip
        isAuthorized={isAuthorized}
        title={disabled ? disabledTooltip : undefined}
      >
        <div>
          <Button
            ref={ref}
            size='small'
            className={classNames('px-0 h-[32px]', className)}
            disabled={!isAuthorized || disabled}
            data-testid={dataTestId}
            {...rest}
          >
            <Stack
              direction={iconPosition === 'left' ? 'row' : 'row-reverse'}
              gap='8px'
              alignItems='center'
              className={classNames('px-[12px]', {
                'pr-[8px]': icon && iconPosition === 'right',
                'pl-[8px]': icon && iconPosition === 'left',
              })}
            >
              {icon &&
                (typeof icon === 'string' ? (
                  <i
                    className={`${icon} text-xl align-middle min-w-[20px] min-h-[20px] w-[20px] h-[20px] m-[2px]`}
                  />
                ) : (
                  icon
                ))}
              <Typography
                noWrap
                variant='button'
                color='currentcolor'
                className={textClassName}
              >
                {text}
              </Typography>
            </Stack>
          </Button>
        </div>
      </AuthorizationTooltip>
    );
  }
);

export { ButtonWithIcon };
